import { render } from "./InvoiceView.vue?vue&type=template&id=bf9d2e7e&scoped=true"
import script from "./InvoiceView.vue?vue&type=script&lang=js"
export * from "./InvoiceView.vue?vue&type=script&lang=js"

import "./InvoiceView.vue?vue&type=style&index=0&id=bf9d2e7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf9d2e7e"]])

export default __exports__